import { render, staticRenderFns } from "./trainList.vue?vue&type=template&id=58dea8f9&scoped=true&"
import script from "./trainList.vue?vue&type=script&lang=ts&"
export * from "./trainList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dea8f9",
  null
  
)

export default component.exports